import { render, staticRenderFns } from "./addaccountMg.vue?vue&type=template&id=119768d4&"
import script from "./addaccountMg.vue?vue&type=script&lang=js&"
export * from "./addaccountMg.vue?vue&type=script&lang=js&"
import style0 from "./addaccountMg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('119768d4')) {
      api.createRecord('119768d4', component.options)
    } else {
      api.reload('119768d4', component.options)
    }
    module.hot.accept("./addaccountMg.vue?vue&type=template&id=119768d4&", function () {
      api.rerender('119768d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/facebook/components/addaccountMg.vue"
export default component.exports